// Temporary: force LLM pipeline while testing (set false once .env.local is picked up after npm restart)
const FORCE_LLM_EXTRACTION = true;

export const isLlmExtractionEnabled = () =>
  FORCE_LLM_EXTRACTION ||
  String(process.env.REACT_APP_OCR_USE_LLM || "").toLowerCase() === "true";
export const getPollIntervalMs = () => {
  const value = Number(process.env.REACT_APP_OCR_JOB_POLL_INTERVAL_MS);
  return Number.isFinite(value) && value > 0 ? value : 3000;
};

export const getMaxWaitMs = () => {
  const value = Number(process.env.REACT_APP_OCR_JOB_MAX_WAIT_MS);
  return Number.isFinite(value) && value > 0 ? value : 900000;
};
